// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControlLabel,
  Radio,
  // Collapse,
  Autocomplete,
  Paper,
  Tooltip,
  Checkbox,
  CircularProgress,
} from "@mui/material";

//MUI ICON
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import InfoIcon from "@mui/icons-material/Info";

// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

//Components
import Dropzone from "components/Dropzone_one";

// import CustomDropzone from "components/Dropzone";
import {
  GradientButton,
  // GradientOutline,
  GradientButtonOutline,
  GradientShadow,
} from "components/GradientButton";
import Form from "components/Form/FormSell";

// API
import api from "_api";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import SaveIcon from "assets/images/SaveIcon.svg";
import { CheckCircle } from "@mui/icons-material";

// ฟังก์ชันสำหรับสร้าง validation schema ให้กับฟอร์ม
const validationSchema = Yup.object({
  // product_code: Yup.string().required("Required"),
  // is_warranty_enabled: Yup.boolean(),
  // product_name: Yup.string().required("โปรดระบุชื่อสินค้า"),
  // category_id: Yup.object().nullable().required("โปรดระบุหมวดหมู่"),
  // detail: Yup.string().required("Required"),
  // blemishes: Yup.string().required("Required"),
  // size: Yup.string().required("Required"),
  // remaining_amount: Yup.number()
  //   .required("โปรดระบุจํานวน")
  //   .min(1, "ไม่สามารถน้อยกว่า 0"),
  // price: Yup.number()
  //   .required("โปรดระบุราคาต่อชิ้น")
  //   .min(0, "ไม่สามารถติดลบได้"),
  // total_price: Yup.number()
  //   .required("โปรดระบุราคาทั้งหมด")
  //   .min(0, "ไม่สามารถติดลบได้"),
  fullName: Yup.string().required("โปรดระบุชื่อ-สกุล"),
  idCardNumber: Yup.string()
    .length(13, "รหัสบัตรประชาชนต้องมี 13 หลัก")
    .matches(/^\d+$/, "รหัสบัตรประชาชนต้องเป็นตัวเลขเท่านั้น")
    .required("โปรดระบุรหัสบัตรประชาชน"),
  phoneNumber: Yup.string()
    // .length(10, "Phone number must be exactly 9 digits")
    .min(9, "หมายเลขโทรศัพท์ต้องมีอย่างน้อย 9 หลัก")
    .max(10, "หมายเลขโทรศัพท์กรอกได้มากสุด 10 หลัก")
    .matches(/^\d+$/, "หม่ายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น")
    .required("โปรดระบุหมายเลขโทรศัพท์"),
  address: Yup.string().required("โปรดระบุที่อยู่"),
  sell_price: Yup.number().required("โปรระบุราคาขาย"),
  amount: Yup.number()
    .required("กรุณาระบุจำนวนที่ต้องการ")
    .test(
      "not-greater-than-total",
      "ไม่สามารถทำรายได้เนื่องจากจำนวนสินค้าไม่เพียงพอ",
      function (value) {
        return value <= this.parent.remaining_amount;
      }
    ),
  discount_rate: Yup.number().min(0, "Discount rate cannot be less than 0"),
  resale_product_percentage: Yup.number()
    .min(0, "Percentage must be at least 0")
    .max(100, "Percentage must not exceed 100")
    .when("is_warranty_enabled", {
      is: true,
      then: Yup.number().required("Required when warranty is enabled"),
    }),
  change_product_percentage: Yup.number()
    .min(0, "Percentage must be at least 0")
    .max(100, "Percentage must not exceed 100")
    .when("is_warranty_enabled", {
      is: true,
      then: Yup.number().required("Required when warranty is enabled"),
    }),
  // .required("Discount rate is required"),
});

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  {
    label: "ชื่อ-นามสกุล",
    name: "fullName",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    label: "ที่อยู่",
    name: "address",
    type: "text",
    required: true,
    disabled: true,
  },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const market_channelOptions = [
  { label: "หน้าร้าน", id: "หน้าร้าน" },
  { label: "Marketplace", id: "Marketplace" },
];

const payment_channelOptions = [
  { label: "เงินสด", id: "เงินสด" },
  { label: "เงินโอน", id: "โอนผ่านธนาคาร" },
  { label: "เช็ค", id: "เช็ค" },
  { label: "บัตรเครดิต", id: "บัตรเครดิต" },
];

const ModalCreateReadyItems = ({
  open,
  onClose,
  selectedProduct,
  fetchProductData,
}) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: true },
  ]);
  const [expandedRow, setExpandedRow] = useState(null); // เก็บการแสดงผลของ Row ในการ Explaned
  const [statusSave, setStatusSave] = useState(false); // เก็บ status หลังจากมีการเพิ่ม Box
  const [currentStep, setCurrentStep] = useState(1); // Track the current step
  const [selectedOption, setSelectedOption] = useState(1); // For selecting the display count option
  const [activeButton, setActiveButton] = useState("pawnContract");

  //เก็บตัวแปร id หลังจากสร้าง product เสร็จ
  const [newIds, setNewIds] = useState([]);
  const [order, setOrder] = useState(null);

  // loading and success state
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  // useEffect(() => {
  //   if (selectedProduct) {
  //     // console.log('check image',selectedProduct)
  //     if (selectedProduct.picture && Array.isArray(selectedProduct.picture)) {
  //       const productImageUrls = selectedProduct.picture.map(
  //         (img) => img.picture
  //       );
  //       setInitialProductUrls(productImageUrls);
  //     }
  //     // if (selectedProduct.customer_image) {
  //     //   setInitialCustomerUrls([selectedProduct.customer_image]);
  //     // }
  //   }
  // }, [selectedProduct]);

  // console.log("checking picture display in modal", initialProductUrls);
  useEffect(() => {
    if (selectedProduct) {
      console.log("แสดงผล selectedProduct", selectedProduct);
      formik.setValues({
        product_code: selectedProduct.product_code || "",
        product_name: selectedProduct.product_name || "",
        category_id: selectedProduct.category_id
          ? categoryOptions.find(
              (category) => category.id === selectedProduct.category_id
            )?.id || ""
          : "",
        detail: selectedProduct.detail || "",
        blemishes: selectedProduct.blemishes || "",
        size: selectedProduct.size || "",
        sell_price: selectedProduct.sell_price || "",
        remaining_amount: selectedProduct.remaining_amount || 1,
        price: selectedProduct.price || 0,
        total_price: selectedProduct.total_price || 0,
        images: selectedProduct.picture?.map((pic) => pic.picture[0]) || [],
      });
    }
  }, [selectedProduct, categoryOptions]);

  //ฟังก์ชันเปลี่ยนหน้า
  const handleNextStep = () => {
    setCurrentStep(currentStep + 1); // Go to the next "page"
  };

  //ฟังก์ชันสำหรับการเปลี่ยนหน้าแสดงผลใน Modal
  const handleBackToStep1 = () => {
    setCurrentStep(1); // Reset back to the first step if needed
  };

  // Function to convert object to FormData
  const tranFormObjectToFormData = (obj) => {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
      if (
        (key === "category_id" ||
          key === "payment_channel" ||
          key === "market_channel") &&
        value &&
        value.id
      ) {
        formData.append(key, value.id);
      } else if (Array.isArray(value)) {
        value.forEach((file, index) => {
          formData.append(`${key}[${index}]`, file);
        });
      } else {
        formData.append(key, value);
      }
    });
    return formData;
  };

  const objectToFormData = (obj, formData = new FormData(), parentKey = "") => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        // ตรวจสอบว่า key นั้นเป็น property ของ obj เอง
        const value = obj[key];
        const formKey = parentKey ? `${parentKey}[${key}]` : key; // จัดการสร้างคีย์สำหรับกรณีของออบเจ็กต์ซ้อน

        if (value instanceof File) {
          // ตรวจสอบว่าค่านั้นเป็นไฟล์หรือไม่
          formData.append(formKey, value); // เพิ่มไฟล์ลงใน formData
        } else if (typeof value === "object" && value !== null) {
          // ถ้าค่าเป็นออบเจ็กต์
          objectToFormData(value, formData, formKey); // เรียกใช้งานฟังก์ชันแบบ recursive
        } else {
          formData.append(formKey, value); // เพิ่มค่านั้นลงใน formData
        }
      }
    }
    return formData; // คืนค่า formData ที่สร้างเสร็จแล้ว
  };

  const buttons = [
    { key: "pawnContract", label: "ใบเสร็จรับเงิน" },
    { key: "saleRenewal", label: "ใบกำกับภาษี" },
    { key: "safe", label: "ใบประกันสินค้า" },
  ];

  // const handleCheckboxChange = (event) => {
  //   setIsChecked(event.target.checked);
  // };

  // Formik hook
  const formik = useFormik({
    initialValues: {
      //สำหรับกำหนดค่า สินค้า
      product_code: "",
      product_name: "",
      category_id: null,
      detail: "",
      blemishes: "",
      size: "",
      remaining_amount: 1,
      price: 0,
      sell_price: 0,
      total_price: 0,
      //สำหรับกำหนดค่า รายละเอียดลูกค้า
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
      //สำหรับกำหนดค่า รายละเอียดการขาย
      payment_channel: "",
      market_channel: "",
      amount: 0,
      price_detail: "",
      discount_price: 0,
      total_discount_price: 0,
      discount_rate: 0,
      sum_discount_price: 0,
      // total_price: 0,
      order_total_price: "",
      //ใบประกัน
      is_warranty_enabled: false,
      resale_product_percentage: 0,
      change_product_percentage: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        // console.log("เข้าอยู่นะ");
        // สร้างข้อมูลผลิตภัณฑ์
        const customerData = {
          fullName: values.fullName,
          idCardNumber: values.idCardNumber,
          phoneNumber: values.phoneNumber,
          address: values.address,
          file: files2.map((fileObj) => fileObj.file),
        };
        console.log("customerData", customerData);
        const customerFormData = tranFormObjectToFormData(customerData);
        const customerResponse = await api.product.createSellCustomer(
          customerFormData
        );

        if (customerResponse.isStatus) {
          // สร้างคำสั่งซื้อถ้าทั้งผลิตภัณฑ์และลูกค้าถูกสร้างขึ้นสำเร็จ
          const orderData = {
            customer: {
              id: customerResponse.data.id,
            },
            product: {
              product_id: selectedProduct.product_id,
              price: values.sell_price,
              selling_amount: values.amount,
              payment_channel: values.payment_channel.id,
              market_channel: values.market_channel.id,
              special_discount: values.discount_price || 0,
              resale_product_percentage: values.order_total_price || 0,
              change_product_percentage: values.discount_rate || 0,
              file: files1.map((fileObj) => fileObj.file),
            },
          };

          const orderFormData = objectToFormData(orderData);
          const orderResponse = await api.product.createSellOrder(
            orderFormData
          );

          // console.log({ orderResponse });

          if (orderResponse.isStatus) {
            // setFiles1([]); // Clear product images
            // setFiles2([]); // Clear customer images
            // resetForm();
            // onClose();
            // fetchProductData();
            // setCurrentStep(1);
            // setProductBoxes([{ id: 1, isExpanded: false }]);
            // setNewIds([]);

            // สร้างคำสั่งซื้อเสร็จสิ้น
            setOrder(orderResponse.data);
            setTimeout(() => {
              setLoading(false);
              setIsSuccess(true);
            }, 1000);
          } else {
            setLoading(false);
            console.error("Error creating order.");
          }
        } else {
          console.error("Error creating customer.");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
  });

  const handlePrintPDF = async () => {
    await api.product
      .getGenerateAndPrintPdfSellOrder(order?.id)
      .then((res) => {
        // console.log("res", res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const handleClose = () => {
    setFiles1([]); // Clear product images
    setFiles2([]); // Clear customer images
    formik.resetForm();
    onClose();
    setIsSuccess(false);
    fetchProductData();
    setCurrentStep(1);
    setProductBoxes([{ id: 1, isExpanded: false }]);
    setNewIds([]);
  };

  //กำหนดให้ ส่วนลดพิเศษ ไม่น้อยกว่า 0
  const handleDiscountRateChange = (event) => {
    const value = event.target.value;
    formik.setFieldValue("discount_rate", value === "" ? 0 : value);
  };

  useEffect(() => {
    const { sell_price, amount, discount_rate } = formik.values;

    // Validate inputs
    const salesPrice = parseFloat(sell_price) || 0;
    const salesAmount = parseFloat(amount) || 0;
    const discountRate = parseFloat(discount_rate) || 0;

    if (salesPrice && discountRate) {
      // Perform calculations
      const discountPrice = salesPrice * (discountRate / 100);
      const totalDiscountPrice = salesPrice - discountPrice;
      const orderPrice = salesAmount * totalDiscountPrice;

      // Update form fields only if values have changed
      if (formik.values.discount_price !== discountPrice.toFixed(2)) {
        formik.setFieldValue("discount_price", discountPrice.toFixed(2));
      }
      if (
        formik.values.total_discount_price !== totalDiscountPrice.toFixed(2)
      ) {
        formik.setFieldValue(
          "total_discount_price",
          totalDiscountPrice.toFixed(2)
        );
      }
      if (formik.values.order_total_price !== orderPrice.toFixed(2)) {
        formik.setFieldValue("order_total_price", orderPrice.toFixed(2));
      }
    } else if (salesPrice && discountRate == 0) {
      const orderPrice = salesAmount * salesPrice;
      formik.setFieldValue("order_total_price", orderPrice.toFixed(2));
      formik.setFieldValue("discount_price", 0);
      formik.setFieldValue("total_discount_price", orderPrice.toFixed(2));
    }
  }, [
    formik.values.sell_price,
    formik.values.amount,
    formik.values.discount_rate,
  ]);

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFieldsCustomer = (fields) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>
            <TextField
              // disabled={field.disabled}
              id={field.name}
              name={field.name}
              type={field.type}
              value={formik.values[field.name]}
              onChange={formik.handleChange}
              {...getFieldProps(field.name)}
              error={
                formik.touched[field.name] && Boolean(formik.errors[field.name])
              }
              helperText={
                formik.touched[field.name] && formik.errors[field.name]
              }
              fullWidth
              InputProps={{
                sx: { height: "40px", padding: "0px" }, // Ensure consistent height and padding
                inputProps: {
                  style: {
                    "-moz-appearance": "textfield",
                    "-webkit-appearance": "none",
                    appearance: "none",
                  },
                  maxLength:
                    field.name === "idCardNumber"
                      ? 13
                      : field.name === "phoneNumber"
                      ? 10
                      : undefined,
                  inputMode: field.type === "text" ? "numeric" : undefined,
                  pattern: field.type === "text" ? "[0-9]*" : undefined,
                },
              }}
            />
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  // ฟังก์ชันการแสดงฟิลด์ของ Product
  const renderProductBoxes = () => {
    return productBoxes.map((box) => (
      <Box
        key={box.id}
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2} style={{ marginTop: "5px" }}>
          {/* <Divider sx={{ borderColor: "#00BB9F", borderWidth: 1 }} /> */}
          {/* Product Code2 Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>รหัส 2 {""}</Typography>
                  <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                    <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                  </Tooltip>
                </div>
              </Grid>

              <Grid item xs={10}>
                <TextField
                  disabled
                  fullWidth
                  name={`product_code_com`}
                  value={formik.values.product_code_com || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched[`product_code_com`] &&
                    Boolean(formik.errors[`product_code_com`])
                  }
                  helperText={
                    formik.touched[`product_code_com`] &&
                    formik.errors[`product_code_com`]
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Name Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ชื่อสินค้า{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`product_name`}
                  value={formik.values.product_name || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.product_name &&
                    Boolean(formik.errors.product_name)
                  }
                  helperText={
                    formik.touched.product_name && formik.errors.product_name
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Category Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หมวดหมู่{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  disabled
                  id={`category_id`}
                  options={categoryOptions}
                  getOptionLabel={(option) => option.label || ""}
                  value={
                    categoryOptions.find(
                      (category) => category.id === formik.values.category_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(`category_id`, newValue?.id || ""); // Store only the id in Formik's state
                  }}
                  fullWidth
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      height: "40px",
                      padding: "0 8px",
                    },
                    ".MuiOutlinedInput-root": {
                      height: "40px",
                    },
                    ".MuiAutocomplete-input": {
                      padding: "0px",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name={`category_id`}
                      error={
                        formik.touched.category_id &&
                        Boolean(formik.errors.category_id)
                      }
                      helperText={
                        formik.touched.category_id && formik.errors.category_id
                      }
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: { height: "40px", padding: "0px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Detail Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>รายละเอียด</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`detail`}
                  value={formik.values.detail || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={formik.touched.detail && Boolean(formik.errors.detail)}
                  helperText={formik.touched.detail && formik.errors.detail}
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Blemishes Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ตำหนิ</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`blemishes`}
                  value={formik.values.blemishes || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.blemishes && Boolean(formik.errors.blemishes)
                  }
                  helperText={
                    formik.touched.blemishes && formik.errors.blemishes
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Size Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ขนาด</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`size`}
                  value={formik.values.size || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={formik.touched.size && Boolean(formik.errors.size)}
                  helperText={formik.touched.size && formik.errors.size}
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Total amount Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  จำนวน{" "}
                  {/* <span style={{ color: "red", marginLeft: "3px" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`remaining_amount`}
                  value={formik.values.remaining_amount || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.remaining_amount &&
                    Boolean(formik.errors.remaining_amount)
                  }
                  helperText={
                    formik.touched.remaining_amount &&
                    formik.errors.remaining_amount
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Price Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ราคาทุน{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`price`}
                  value={formik.values.price || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.price && Boolean(formik.errors.price)}
                  helperText={formik.touched.price && formik.errors.price}
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Total Price Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ราคารวม
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name="total_price"
                  value={
                    formik.values.remaining_amount && formik.values.price
                      ? (
                          Number(formik.values.remaining_amount) *
                          Number(formik.values.price)
                        ).toFixed(2)
                      : ""
                  }
                  // No onChange because total_price is calculated dynamically
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.total_price &&
                    Boolean(formik.errors.total_price)
                  }
                  helperText={
                    formik.touched.total_price && formik.errors.total_price
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Notes Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>หมายเหตุ</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`notes`}
                  value={formik.values.notes || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={formik.touched.notes && Boolean(formik.errors.notes)}
                  helperText={formik.touched.notes && formik.errors.notes}
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Image Row */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              รูปทรัพย์
            </Typography>
            <Grid item xs={12}>
              {Array.isArray(formik.values.images) &&
              formik.values.images.length > 0 ? (
                <div>
                  {formik.values.images.map((imageUrl, index) => (
                    <img
                      key={index}
                      src={imageUrl}
                      alt={`Image ${index + 1} for Box ${box.id}`}
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        marginRight: "10px",
                      }}
                    />
                  ))}
                </div>
              ) : (
                <p>No images available for Box {box.id}</p>
              )}
            </Grid>

            {error1 && (
              <Typography variant="caption" color="error">
                {error1}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    ));
  };

  // ฟังก์ชันการแสดง ช่องทางการชำระ
  const renderFieldsPayment = () => {
    return (
      <Box
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          {/* Product Payment Channel Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ช่องทางการชำระ{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  id={`payment_channel`}
                  options={payment_channelOptions}
                  getOptionLabel={(option) => option.label}
                  value={formik.values.payment_channel}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(`payment_channel`, newValue);
                  }}
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      height: "40px",
                      padding: "0px 0px 0px 5px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name={`payment_channel`}
                      error={
                        formik.touched.payment_channel &&
                        Boolean(formik.errors.payment_channel)
                      }
                      helperText={
                        formik.touched.payment_channel &&
                        formik.errors.payment_channel
                      }
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: { height: "40px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Slip Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  หลักฐานการชำระเงิน{""}
                  {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Dropzone
                  files={files1}
                  setFiles={setFiles1}
                  setError={setError1}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Market Channel Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ช่องทางการขาย{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  id={`market_channel`}
                  options={market_channelOptions}
                  getOptionLabel={(option) => option.label}
                  value={formik.values.market_channel}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(`market_channel`, newValue);
                  }}
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      height: "40px",
                      padding: "0px 0px 0px 5px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name={`market_channel`}
                      error={
                        formik.touched.market_channel &&
                        Boolean(formik.errors.market_channel)
                      }
                      helperText={
                        formik.touched.market_channel &&
                        formik.errors.market_channel
                      }
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: { height: "40px" },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Amount Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  จำนวนที่ขาย{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  name="amount"
                  value={formik.values.amount || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.amount && Boolean(formik.errors.amount)}
                  helperText={formik.touched.amount && formik.errors.amount}
                  InputProps={{
                    sx: { height: "40px", padding: "0px" },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Sales Price Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>
                  ราคาขาย{""}
                  <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name={`sell_price`}
                  value={formik.values.sell_price || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.sell_price &&
                    Boolean(formik.errors.sell_price)
                  }
                  helperText={
                    formik.touched.sell_price && formik.errors.sell_price
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ marginLeft: 2, textAlign: "right" }}>
                  เป็นราคาตั้งราคาขาย แบบ 1 ชิ้น {formik.values.sell_price || 0}{" "}
                  บาท
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Discount Rate Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ส่วนลดพิเศษ</Typography>
              </Grid>
              <Grid item xs={2} display="flex" alignItems="center">
                <TextField
                  fullWidth
                  name="discount_rate"
                  value={
                    formik.values.discount_rate === ""
                      ? 0
                      : formik.values.discount_rate
                  }
                  defaultValue={0}
                  onChange={handleDiscountRateChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.discount_rate &&
                    Boolean(formik.errors.discount_rate)
                  }
                  helperText={
                    formik.touched.discount_rate && formik.errors.discount_rate
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" },
                  }}
                />
                <Typography sx={{ marginLeft: "5px" }}> % </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm={8}
                container
                alignItems="center"
                justifyContent="flex-end"
                spacing={1}
              >
                <Grid
                  item
                  xs={4}
                  sm={2}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Typography>คิดเป็นเงิน</Typography>
                </Grid>
                <Grid item xs={8} sm={10}>
                  <TextField
                    disabled
                    fullWidth
                    name="discount_price"
                    value={formik.values.discount_price}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.discount_price &&
                      Boolean(formik.errors.discount_price)
                    }
                    helperText={
                      formik.touched.discount_price &&
                      formik.errors.discount_price
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" },
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Product Discount Price Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>ราคาหลังหักส่วนลด</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`total_discount_price`}
                  value={formik.values.total_discount_price || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.total_discount_price &&
                    Boolean(formik.errors.total_discount_price)
                  }
                  helperText={
                    formik.touched.total_discount_price &&
                    formik.errors.total_discount_price
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Product Blemishes Row */}
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography>รวมจำนวนเงินทั้งสิ้น</Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  name={`order_total_price`}
                  value={formik.values.order_total_price || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur} // <-- Add onBlur
                  error={
                    formik.touched.order_total_price &&
                    Boolean(formik.errors.order_total_price)
                  }
                  helperText={
                    formik.touched.order_total_price &&
                    formik.errors.order_total_price
                  }
                  InputProps={{
                    sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={1} alignItems="center">
              {/* Checkbox and Label */}
              <Grid item xs={2} display="flex" alignItems="center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formik.values.is_warranty_enabled}
                      onChange={formik.handleChange}
                      name="is_warranty_enabled"
                    />
                  }
                  label="ใบรับประกันสินค้า"
                />
              </Grid>

              {/* First Section: Label and Field */}
              <Grid
                item
                xs={2}
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Typography textAlign="right">กรณีขายคืนสินค้าหัก</Typography>
              </Grid>

              <Grid item xs={1} display="flex" alignItems="center">
                <TextField
                  size="small"
                  name="resale_product_percentage"
                  value={formik.values.resale_product_percentage}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!formik.values.is_warranty_enabled}
                  error={
                    formik.touched.resale_product_percentage &&
                    Boolean(formik.errors.resale_product_percentage)
                  }
                  helperText={
                    formik.touched.resale_product_percentage &&
                    formik.errors.resale_product_percentage
                  }
                  InputProps={{
                    endAdornment: (
                      <Typography sx={{ marginLeft: "4px" }}> %</Typography>
                    ),
                  }}
                />
              </Grid>

              <Grid
                item
                xs={1}
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Typography textAlign="right">เปลี่ยนหัก</Typography>
              </Grid>

              <Grid item xs={1} display="flex" alignItems="center">
                <TextField
                  size="small"
                  name="change_product_percentage"
                  value={formik.values.change_product_percentage}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!formik.values.is_warranty_enabled}
                  error={
                    formik.touched.change_product_percentage &&
                    Boolean(formik.errors.change_product_percentage)
                  }
                  helperText={
                    formik.touched.change_product_percentage &&
                    formik.errors.change_product_percentage
                  }
                  InputProps={{
                    endAdornment: (
                      <Typography sx={{ marginLeft: "4px" }}> %</Typography>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={3}>
                <Typography>ของมูลค่าสินค้าตามใบรับประกัน</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  };

  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setInitialProductUrls([]); // Clear initial product image URLs
                  // setInitialCustomerUrls([]);
                  setDeletedImageIds([]);
                  onClose();
                  setNewIds([]);
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
      setNewIds([]);
    }
  };

  // Function to handle button click
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName); // Set the clicked button as active
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  // ใช้สำหรับการคิดค่าของ ราคา * จำนวน = จำนวนทั้งหมดแล้วนำไปเก็บไว้ใน Formik id นั้นๆ
  useEffect(() => {
    productBoxes.forEach((box) => {
      const totalAmount = formik.values[`remaining_amount`];
      const price = formik.values[`price_`];

      if (totalAmount && price) {
        const totalPrice = Number(totalAmount) * Number(price);
        formik.setFieldValue(`total_price`, totalPrice);
      }
    });
  }, [formik.values, formik.setFieldValue, productBoxes]);

  const handleLog = () => {
    console.log("This is submit");
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      {currentStep === 1 ? (
        <>
          {/* หน้าที่ 1 : Form */}
          <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
            <Typography variant="h4">ขายสินค้า</Typography>
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
            <form onSubmit={formik.handleSubmit}>
              {/* Render the product boxes */}
              <Grid item xs={12} sx={{ mx: 2 }}>
                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  ข้อมูลลูกค้า
                </Typography>
                <Paper sx={{ p: 2, borderRadius: "12px" }}>
                  <Grid container>
                    <Grid item xs={7}>
                      {renderFieldsCustomer(customerFields)}
                    </Grid>
                    <Grid item xs={5} sx={{ mt: 2 }}>
                      <Dropzone
                        files={files2}
                        setFiles={setFiles2}
                        setError={setError2}
                      />
                      {error2 && (
                        <Typography variant="caption" color="error">
                          {error2}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>

                <Grid items xs={12}>
                  {/* Render the product boxes */}
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    ข้อมูลสินค้า
                  </Typography>
                  {renderProductBoxes()}
                </Grid>

                <Grid items xs={12}>
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    รายละเอียดการขาย
                  </Typography>
                  {renderFieldsPayment()}
                </Grid>
              </Grid>
            </form>
          </DialogContent>

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    borderRadius: "12px", // Make the button circular
                    minWidth: "40px", // Adjust the width
                    minHeight: "40px", // Adjust the height
                    padding: 0, // Remove padding to center the icon better
                    borderColor: "#c4c4c4", // Light grey border
                    color: "#6c6c6c", // Light grey icon color
                    display: "flex", // Ensure flexbox is used
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                    "&:hover": {
                      borderColor: "#a0a0a0", // Darker grey on hover
                    },
                  }}
                >
                  <ArrowBackIosIcon
                    fontSize="small"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </Button>
                <GradientButtonOutline type="submit" onClick={handleNextStep}>
                  ดูตัวอย่าง
                </GradientButtonOutline>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      ) : (
        <>
          {/* Step 2: Confirmation Page */}
          <DialogTitle>
            <Typography variant="h4">ตัวอย่างแบบฟอร์มรายการขาย</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container>
              {/* Left Side: Form Section */}
              <Grid
                item
                xs={8}
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  height: "650px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                {activeButton === "pawnContract" ? (
                  <Form data={formik.values} />
                ) : activeButton === "saleRenewal" ? (
                  <Form data={formik.values} vat={"7"} />
                ) : null}
              </Grid>

              {/* Right Side: Buttons Section */}
              <Grid
                item
                xs={4}
                display="flex"
                flexDirection="column"
                sx={{ padding: 2 }}
              >
                {buttons.map((button) => (
                  <GradientShadow
                    key={button.key}
                    isActive={activeButton === button.key}
                    onClick={() => handleButtonClick(button.key)}
                    sx={{ margin: "10px" }}
                  >
                    {button.label}
                  </GradientShadow>
                ))}
              </Grid>
            </Grid>
          </DialogContent>

          {/* <Divider style={{ marginTop: "0", marginBottom: "16px", mx: 2 }} /> */}

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              // backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <GradientButtonOutline
                  // GradientButtonOutlineon
                  onClick={handleBackToStep1}
                >
                  ยกเลิก
                </GradientButtonOutline>
                <Grid>
                  {isSuccess ? (
                    <>
                      <GradientButtonOutline
                        sx={{
                          width: "120px",
                          marginRight: "20px",
                        }}
                        endIcon={
                          <CheckCircle
                            sx={{
                              width: "16px",
                              height: "16px",
                            }}
                          />
                        }
                        id="btn-success"
                        onClick={handleClose}
                      >
                        เสร็จสิ้น
                      </GradientButtonOutline>
                      <GradientButton
                        id="btn-print-pdf"
                        onClick={handlePrintPDF}
                        sx={{ width: "100px" }}
                      >
                        พิมพ์
                      </GradientButton>
                    </>
                  ) : (
                    <>
                      <GradientButton
                        type="submit"
                        onClick={formik.handleSubmit}
                        style={{ marginRight: "20px", width: "150px" }}
                        disabled={loading}
                        endIcon={
                          loading ? (
                            <CircularProgress
                              color="inherit"
                              size={15}
                              thickness={5}
                            />
                          ) : null
                        }
                      >
                        บันทึก
                      </GradientButton>
                      <Tooltip
                        title={
                          <Typography
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            กรุณากดบันทึกก่อนพิมพ์
                          </Typography>
                        }
                        arrow={true}
                        placement="top"
                        disableHoverListener={isSuccess} // ปิด tooltip ถ้า isSuccess = true
                        disableFocusListener={isSuccess}
                      >
                        <span>
                          <GradientButtonOutline
                            disabled={!isSuccess}
                            sx={{
                              width: "100px",
                              border: "1px solid #ccc",
                            }}
                          >
                            พิมพ์
                          </GradientButtonOutline>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalCreateReadyItems;
